import useApiQuery from '../useApiQuery';

export interface SavV2Counts {
  unassigned: number;
  mySavs: number;
  searchingRepairer: number;
  waitingQuoteBeneficiary: number;
  waitingQuoteManager: number;
  transcribingQuote: number;
  analyzingQuote: number;
  formalizingDecision: number;
  refusedGarant: number;
  directCoverage: number;
  waitingGarantSignature: number;
  waitingBeneficiarySignature: number;
  newBeneficiaryMessages: number;
  newInternalMessages: number;
}

/**
 * Hook pour récupérer les counts des filtres SAV v2
 * Utilisé pour afficher les badges dans la sidebar
 *
 * @param managerFilter - Filtre optionnel par gestionnaire ('my-savs', 'unassigned', UUID du gestionnaire, ou undefined pour tous)
 */
export function useSavV2Counts(managerFilter?: string) {
  const { data: counts, refetch, isLoading, error } = useApiQuery<SavV2Counts>(
    'sav-v2/filtered-list/counts',
    {
      params: managerFilter ? { managerFilter } : undefined,
    }
  );

  return {
    counts,
    refetch,
    isLoading,
    error,
  };
}
